import { TableRow, TableCell, Checkbox } from '@sanlam-glacier/app-common/components';
import { Client, useReportForm } from 'modules/reports/hooks/useReportFormContext';

type ReportTableProps = {
  row: {
    id: number;
    clientName: string;
    clientSurname: string;
    investmentType: string;
  };
  toggleClient: (client: Client) => void;
};

export const ReportTableRow = ({ row, toggleClient }: ReportTableProps) => {
  const { formData } = useReportForm();
  const isSelected = formData.clients.some((c) => c.id === row.id);

  return (
    <TableRow key={row.id}>
      <TableCell>
        <Checkbox checked={isSelected} onChange={() => toggleClient(row)} />
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT}>{row.clientName}</TableCell>
      <TableCell align={TableCell.ALIGN.LEFT}>{row.clientSurname}</TableCell>
      <TableCell align={TableCell.ALIGN.LEFT}>{row.investmentType}</TableCell>
    </TableRow>
  );
};
